<div class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Mailing Label</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <app-data-form
      [dataFields]="FormFields"
      (updateFields_child)="update()"
    />
    <button
      class="shorter-btn print-btn"
      [disabled]="lockPrint"
      (click)="print()"
    >
      <fa-icon [icon]="faPrint" class="mr-1" />Print
    </button>
  </div>
</div>
